<template>
    <xx-panel class="detail" :title="title">
        <slot name="before"></slot>
        <el-form label-suffix=":" :label-width="labelWidth">
            <el-row v-for="(fields, index) in computedFields" :key="index">
                <el-col :lg="lgNum" :md="mdNum" v-for="(field, index) in fields" :key="index">
                    <el-form-item>
                        <template slot="label">
                            <span :class="field.labelClass">{{ field.label }}</span>
                        </template>
                        <span :class="field.valueClass">{{ field.value || defaultVal }}</span>
                        <el-tooltip v-if="field.help" effect="dark" :content="field.help" placement="top">
                             <i :class="[field.iconName || 'el-icon-question', 'icon-style']" @click="helpClickHandler(field)"></i>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <slot name="after"></slot>
    </xx-panel>
</template>

<script>
/**
 * @author lvxin08
 *
 * 详情页分模块展示, 主要用于统一样式
 */

export default {
    name: 'XxDetailCard',
    props: {
        /**
         * 数据
         */
        data: {
            type: Array,
            default: []
        },
        /**
         * @ignore
         */
        column: {
            type: Number,
            default: 3
        },
        /**
         * 同 el-form
         */
        labelWidth: {
            type: String,
            default: '100px'
        },
        /**
         * 空值时展示的placeholder
         */
        defaultVal: {
            type: String,
            default: '--'
        },
        /**
         * 模块的标题
         */
        title: {
            type: String,
            default: '基本信息'
        },
        /**
         * 模块的帮助信息
         */
        help: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    computed: {
        lgNum() {
            return 24 / this.column;
        },
        mdNum() {
            return 24 / Math.max(this.column - 1, 1);
        },
        computedFields() {
            let ret = [];
            let tempArr = [];
            this.data.forEach((v, i) => {
                if (i % this.column === 0) {
                    ret.push(tempArr);
                    tempArr = [];
                }
                tempArr.push(v);
            });
            ret.push(tempArr);
            return ret.slice(1);
        }
    },
    methods: {
        helpClickHandler(field) {
            this.$emit('help-click', field);
        }
    }
};
</script>

<style lang="scss" scoped>
.detail {
    /deep/ {
        .el-form-item {
            margin-bottom: 0;
        }
        .el-form-item__content,
        .el-form-item__label {
            line-height: 25px;
        }
    }
}
.icon-style {
  cursor: pointer;
}
</style>
